module.exports = __webpack_public_path__ + "static/img/pic24.fb57df4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic24.png
// module id = wxL5
// module chunks = 0